/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "blustreamREST",
            "endpoint": "https://dl16fivzo8.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "publicshorturl",
            "endpoint": "https://fauqp3ny8h.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xk22paykz5abxjkob7ouy64n3q.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "us-east-1:d2aae1fe-fc25-42bf-90a7-1517c5e7c17b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_1Srkw88rb",
    "aws_user_pools_web_client_id": "1341ot57jm3chpvhg81ettekd",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "blustreamfrontend-20211126150112-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://doy2i6029pnys.cloudfront.net",
    "aws_user_files_s3_bucket": "blustreamfrontenda4c26b55bbdb40489dfdc2867d6081143922-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
